import React, { useContext } from "react";

import { GlobalContext } from "@/helpers/contexts/contexts";
import BrandCoverSocket from "./BrandCoverSocket";
import { USER_ROLE } from "@/config/constants";

function CommonSockets() {
  const { selectedBrand, loggedInUserRole } = useContext(GlobalContext);
  return (
    <>
      {selectedBrand?.id && loggedInUserRole === USER_ROLE.PARTICIPANT.NAME && (
        <BrandCoverSocket brandId={selectedBrand?.id} />
      )}
    </>
  );
}

export default CommonSockets;
